import { BorderGridContainer, GridBox, H2, PortableText } from '@ahmdigital/ui';
import React from 'react';

import { AwardImage, ImageWrapper, StyledSection, TextWrapper } from './styles';
import { SectionAwardType } from '../../types';
import getImageAttributes from '../../../../cms/utils/get-image-attributes';

const Award = ({ imageObject, name, summaryRaw }: SectionAwardType) => {
  const image = getImageAttributes({ height: 200, imageObject });

  return (
    <BorderGridContainer>
      <GridBox padding="1rem">
        <StyledSection variant={['paddingTopSpacer10', 'paddingBottomSpacer10']}>
          <ImageWrapper>{image && <AwardImage alt={image.alt} src={image.src} />}</ImageWrapper>
          <TextWrapper>
            <H2 looksLike="h3" variant={['simpleBit', 'marginBottomSpacer12']}>
              {name}
            </H2>
            <PortableText source={summaryRaw} />
          </TextWrapper>
        </StyledSection>
      </GridBox>
    </BorderGridContainer>
  );
};

export default Award;
